/**
 * Decorator function to wrap methods in a setTimeout (commonly to fix ExpressionChangedAfterItHasBeenCheckedError)
 */
export function timeoutWrapper(milliseconds: number = 0) {
  return (target: object, key: string, descriptor: TypedPropertyDescriptor<any>) => {
    const wrappedFunction = descriptor.value;

    descriptor.value = function(...args) {
      setTimeout(() => {
        wrappedFunction.apply(this, args);
      }, milliseconds);
    };

    return descriptor;
  };
}
